import React, { useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { Link, useLocation, useHistory } from "react-router-dom"
import { useTranslation } from "react-i18next"
import { getSourceSvg, LOCAL_STORAGE_KEYS, SOURCE_TYPE } from "../../utils"
import VisibilityOffRoundedIcon from "@material-ui/icons/VisibilityOffRounded"
import VisibilityRoundedIcon from "@material-ui/icons/VisibilityRounded"
import CircularProgress from "@material-ui/core/CircularProgress"
import { Avatar, Box, Checkbox, IconButton, Tooltip, Typography, makeStyles, useTheme } from "@material-ui/core"
import Button from "@material-ui/core/Button"
import Comments from "../../images/Comments.png"
import { documentsActions } from "../../actions/documentsActions"
import { setSelectedIdsAction, resetSelectedIdsAction } from "../../actions/downloadsActions"
import DownloadSVG from "../../components/icons/DownloadSVG"
import DeleteIcon from "@material-ui/icons/DeleteOutline"
import { setReviewAsignee, setReviewAssigneeMap } from "../../actions/reviewActions"
import TaggedDate from "../../components/taggedDate/TaggedDate"
import ConfirmationDialog from "../../components/common/dialog/ConfirmationDialog"

const useStyles = makeStyles((theme) => ({
	fileNameWrapper: {
		cursor: "pointer",
		"&:hover": {
			textDecoration: "underline",
		},
	},
	assigneeWrapper: {
		display: "flex",
		alignItems: "center",
	},
	avatar: {
		width: 24,
		height: 24,
		fontSize: 14,
		marginRight: 13,
		color: theme.palette.text.primary,
		textTransform: "uppercase",
	},
	assigneeName: {
		fontSize: 14,
		fontWeight: 400,
		color: theme.palette.text.primary,
		display: "inline-block",
		textOverflow: "ellipsis",
		width: "calc(80%)",
		overflow: "hidden",
	},
	deleteModal: {
		"& .MuiDialog-paperWidthSm": {
			maxWidth: 400,
		},
	},
}))

const commentsSection = (params) => {
	const dynamicPadding = params?.row?.comments_count?.toString()?.length >= 2 ? "3px" : "7px"
	return (
		<Box
			style={{
				display: "flex",
				width: "100%",
				backgroundImage: `url(${Comments})`,
				backgroundRepeat: "no-repeat",
				backgroundPosition: "0% 60%",
				marginLeft: "6px",
				paddingLeft: dynamicPadding,
			}}
		>
			{params?.row?.comments_count || 0}
		</Box>
	)
}

// Assigns specific order for DataTable Columns (Table Header and Table Cell)
const getAllDocumentsTableColumns = (
	isEmailType = false,
	renderTagHeader,
	getTags,
	renderEmailDialog,
	fileSelection = () => {},
	rows = [],
	renderTaggedDate = () => {},
	renderPageNumberHeader = () => {}
) => {
	const [t] = useTranslation("global")
	const [open, setOpen] = useState(false)

	const toggle = () => setOpen(!open)
	const dispatch = useDispatch()
	const classes = useStyles()
	let location = useLocation()

	const theme = useTheme()
	const history = useHistory()
	const singleFileDownloadStatus = useSelector((state) => state?.downloads?.documents)
	const singleFileDeleteStatus = useSelector((state) => state?.deleteFile?.documents)

	//reviews
	const reviewAssignee = useSelector((state) => state.review?.reviewAssignee)
	const assigneeMap = useSelector((state) => state.review?.assigneeMap)
	const usersList = useSelector((state) => state.info?.usersList || [])
	const isReviewFormOpen = useSelector((state) => state.review?.isReviewFormOpen)
	const reviewCurrentAsignee = useSelector((state) => state.review?.reviewCurrentAsignee)

	const selectedRowFromRedux = useSelector((state) => state.downloads?.selectedDocumentIds)

	const routeToViewerHandler = (params) => {
		console.log("location?.pathname", location?.pathname, window.location.search)
		if (isReviewFormOpen) return //if create/update review is open then will prevent the document to be open in viewer
		history.push({
			pathname: `${location?.pathname}/viewer/${params?.row?.id}`,
			search: window.location.search,
			state: { prevPath: history?.location?.pathname },
		})

		if (!params?.row?.view_count) {
			localStorage.setItem(LOCAL_STORAGE_KEYS.TRIGGER_P_SEARCH, true)
		}
	}

	const assigneeSection = (params) => {
		return (
			<Box>
				{assigneeMap?.get(params?.row?.id) && (
					<div className={classes.assigneeWrapper}>
						<Avatar className={classes.avatar}>
							{getUserNameInitialsById(usersList, assigneeMap.get(params?.row?.id) || "")}
						</Avatar>
						<Typography className={classes.assigneeName}>
							{getUserNameById(usersList, assigneeMap.get(params?.row?.id) || "")}
						</Typography>
					</div>
				)}
			</Box>
		)
	}

	const handleAsigneeCheckBoxChange = (event) => {
		fileSelection(event?.target?.value, event?.target?.checked)
	}

	const assigneeSelectionSection = (params) => {
		const isChecked = !!assigneeMap?.get(params?.row?.id)
		const isDisabled = !!assigneeMap?.get(params?.row?.id) && assigneeMap?.get(params?.row?.id) !== reviewCurrentAsignee

		return (
			<Box>
				<Checkbox
					checked={isChecked}
					//onChange={handleAsigneeCheckBoxChange}
					value={params?.row?.id}
					onClick={handleAsigneeCheckBoxChange}
					disabled={isDisabled}
				/>
			</Box>
		)
	}

	const handleSelectAllChange = (e) => {
		const isChecked = e?.target?.checked
		const checkedRowsIds = []
		const unCheckedRowIds = []

		for (const iterator of rows) {
			if (!assigneeMap?.has(iterator?.id)) {
				checkedRowsIds.push(iterator?.id)
			} else {
				if (assigneeMap?.get(iterator?.id) === reviewCurrentAsignee) {
					unCheckedRowIds.push(iterator?.id)
				}
			}
		}

		const reviewAssigneeRef = _.cloneDeep(reviewAssignee)
		if (isChecked) {
			const newIds = Object.keys(reviewAssigneeRef[reviewCurrentAsignee])?.length ? [...reviewAssigneeRef[reviewCurrentAsignee]] : []
			reviewAssigneeRef[reviewCurrentAsignee] = [...newIds, ...checkedRowsIds]
		} else {
			const filterIds = reviewAssigneeRef[reviewCurrentAsignee]?.filter((id) => !unCheckedRowIds?.includes(id))
			reviewAssigneeRef[reviewCurrentAsignee] = filterIds
		}

		let assigneeMapClone = _.cloneDeep(assigneeMap)
		if (isChecked) {
			for (const iterator of checkedRowsIds) {
				assigneeMapClone.set(iterator, reviewCurrentAsignee)
			}
		} else {
			for (const iterator of unCheckedRowIds) {
				//assigneeMapClone.delete(iterator)
				assigneeMapClone.set(iterator, null)
			}
		}

		dispatch(setReviewAsignee(reviewAssigneeRef))
		dispatch(setReviewAssigneeMap(assigneeMapClone))
	}

	const renderAsigneeSelectionHeader = () => {
		const isChecked = rows?.every((item) => !!assigneeMap?.has(item.id))
		const isDisabled = rows?.every((item) => !!assigneeMap?.has(item.id) && assigneeMap?.get(item.id) !== reviewCurrentAsignee)

		return (
			<Box>
				<Checkbox
					checked={isChecked}
					//onChange={handleSelectAllChange}
					onClick={handleSelectAllChange}
					disabled={isDisabled || !reviewCurrentAsignee}
					style={{ paddingLeft: 4 }}
				/>
			</Box>
		)
	}

	const downloadFileSelectionSection = (params) => {
		const isChecked = Object.keys(selectedRowFromRedux)?.includes(params?.row?.id)
		return (
			<Box>
				<Checkbox
					checked={isChecked}
					//onChange={handleAsigneeCheckBoxChange}
					value={params?.row?.id}
					onClick={handleDownloadFileSelectionChange}
				/>
			</Box>
		)
	}

	const handleDownloadFileSelectionChange = (event) => {
		const selectedIds = { ...selectedRowFromRedux }
		if (Object.keys(selectedIds)?.includes(event?.target?.value)) {
			delete selectedIds[event?.target?.value]
		} else {
			const size = rows?.filter((row) => row.id === event?.target?.value)[0]?.size
			selectedIds[event?.target?.value] = size
		}

		dispatch(setSelectedIdsAction(selectedIds))
	}

	const renderDownloadFileHeader = () => {
		let isChecked = false
		if (rows?.length > 0) {
			isChecked = rows?.every((item) => Object.keys(selectedRowFromRedux)?.includes(item?.id))
		}
		return (
			<Box>
				<Checkbox checked={isChecked} onClick={handleDownloadFileSelectAllChange} style={{ paddingLeft: 4 }} />
			</Box>
		)
	}
	const handleDownloadFileSelectAllChange = (e) => {
		const isChecked = e?.target?.checked
		let selectedAllValues = {}

		if (isChecked) {
			for (const iterator of rows) {
				selectedAllValues[iterator?.id] = iterator.size
			}
			dispatch(setSelectedIdsAction({ ...selectedRowFromRedux, ...selectedAllValues }))
		} else {
			const deleteAllValues = { ...selectedRowFromRedux }
			for (const iterator of rows) {
				delete deleteAllValues[iterator?.id]
			}
			dispatch(setSelectedIdsAction(deleteAllValues || {}))
		}
	}

	const getUserNameById = (userList, userId) => {
		if (!userId) return ""

		let userName = userList.filter((user) => user?.user_id === userId).map((user) => user?.username)
		return userName?.length > 0 ? userName[0] : ""
	}

	const getUserNameInitialsById = (userList, userId) => {
		if (!userId) return ""

		let userName = userList.filter((user) => user?.user_id === userId).map((user) => user?.username)
		userName = userName?.length > 0 ? userName[0] : ""
		const UserNameInitial = userName?.split(" ")[1]
			? `${userName?.split(" ")[0][0]}${userName?.split(" ")[1][0]}`
			: userName?.split(" ")[0][0]

		return UserNameInitial
	}

	const fileNameSection = (params) => {
		return (
			<Tooltip title={params?.row?.title} placement="top">
				<Box className={classes.fileNameWrapper} style={{ display: "flex" }}>
					<Box style={{ marginRight: "16px" }}>{getSourceSvg(params?.row?.source, params?.row?.attachments)}</Box>
					<Box style={{ display: "flex", alignItems: "center" }}>
						<Box
							//to={`/viewer/1fdc8b9a-9c4f-433c-8700-0836c26f1201/${params?.row?.id}`}
							onClick={() => routeToViewerHandler(params)}
							//component={Link}
							style={{
								...theme.typography.body1,
								textDecoration: "none",
							}}
						>
							<Typography
								style={{
									width: "221px",
									textOverflow: "ellipsis",
									whiteSpace: "nowrap",
									overflow: "hidden",
									color: params?.row?.reviewed ? theme.palette.text.reviewed : "",
								}}
							>
								{params?.row?.title}
							</Typography>
						</Box>
					</Box>
				</Box>
			</Tooltip>
		)
	}

	const viewSection = (params) => {
		return (
			<Box
				style={{
					display: "flex",
					width: "100%",
					marginLeft: "6px",
				}}
				onClick={toggle}
			>
				{params?.row?.view_count ? <VisibilityRoundedIcon /> : <VisibilityOffRoundedIcon />}
			</Box>
		)
	}
	const downloadSection = (params) => {
		const [t] = useTranslation("global")
		const isDownloading = singleFileDownloadStatus[params?.row?.id]?.downloading
		const isDeleting = singleFileDeleteStatus[params?.row?.id]?.deleting
		const fileName = params?.row?.title

		const [openDeleteConfirm, setOpenDeleteConfirm] = useState(false)

		const handleDeleteFile = (file) => {
			if (file) {
				setOpenDeleteConfirm((prev) => false)
				dispatch(documentsActions.deleteSingleFileAction(file?.id, file?.title, file?.source))
			}
		}

		const handleDeleteCancel = () => {
			setOpenDeleteConfirm((prev) => false)
		}

		return (
			<Box
				style={{
					display: "flex",
					justifyContent: "space-between",
					//gap: "8px",
					width: "100%",
				}}
			>
				<Box>
					{isDownloading ? (
						<CircularProgress size={20} />
					) : (
						<Tooltip title={isDeleting ? t("deleteFile.deleting") : t("deleteFile.download")} placement="top" arrow>
							<span>
								<IconButton
									aria-label="download"
									disabled={!!isDeleting}
									onClick={() => {
										dispatch(
											documentsActions.downloadSingleFileAction(
												params?.row?.id,
												params?.row?.name,
												params?.row?.source
											)
										)
									}}
								>
									<DownloadSVG style={{ fill: "inherit" }} />
								</IconButton>
							</span>
						</Tooltip>
					)}
				</Box>
				{params?.row?.can_delete && (
					<>
						<Box>
							{isDeleting ? (
								<CircularProgress size={20} />
							) : (
								<Tooltip title={isDownloading ? t("deleteFile.downloading") : t("deleteFile.delete")} placement="top" arrow>
									<span>
										<IconButton
											aria-label="delete"
											disabled={!!isDownloading}
											onClick={() => setOpenDeleteConfirm(true)}
										>
											<DeleteIcon style={{ fill: "inherit" }} />
										</IconButton>
									</span>
								</Tooltip>
							)}
						</Box>
						<ConfirmationDialog
							open={openDeleteConfirm}
							title={t("deleteFile.deleteFileTitle")}
							message={t("deleteFile.confirmMessage", { fileName })}
							btnText={t("deleteFile.btndelete")}
							onConfirm={() => handleDeleteFile(params?.row)}
							onDismiss={handleDeleteCancel}
							dynamicClass={classes.deleteModal}
						/>
					</>
				)}
			</Box>
		)
	}

	const renderEmailTaggedDate = (params) => {
		return params?.row?.tagged_date ? new Date(params?.row?.tagged_date).toLocaleString() : ""
	}

	const isColmnSortable = () => {
		//if review form is open will disabled the sorting
		return isReviewFormOpen ? false : true
	}

	const showPageNumber = (params) => {
		return (
			<Box
				style={{
					display: "flex",
					width: "100%",
					marginRight: "7px",
					justifyContent: "end",
				}}
			>
				{params?.row?.pages}
			</Box>
		)
	}

	const columns = isEmailType
		? [
				{
					field: "title",
					headerName: t("tableColumns.emailSubject"),
					renderCell: (params) => fileNameSection(params),
					flex: 0.5,
					minWidth: 150,
					sortable: isColmnSortable(),
				},
				{
					field: "pages",
					headerName: t("tableColumns.pages"),
					renderCell: (params) => showPageNumber(params),
					renderHeader: () => renderPageNumberHeader(),
					flex: 0.5,
					minWidth: 150,
					sortable: false,
				},
				{
					field: "tagged_date",
					headerName: t("tableColumns.emailSentDate"),
					renderCell: renderEmailTaggedDate,
					minWidth: 250,
					maxWidth: 270,
					sortable: isColmnSortable(),
				},
				{
					field: "from",
					headerName: t("tableColumns.emailFrom"),
					minWidth: 200,
					maxWidth: 230,
					sortable: isColmnSortable(),
				},
				{
					field: "to",
					headerName: t("tableColumns.emailTo"),
					sortable: false,
					minWidth: 200,
					maxWidth: 230,
					renderCell: (params) => renderEmailDialog(params),
				},
				{
					field: "tags",
					headerName: t("tableColumns.tag"),
					minWidth: 315,
					maxWidth: 315,
					renderHeader: () => renderTagHeader(),
					renderCell: getTags,
					sortable: false,
				},
				{
					field: "view_count",
					headerName: t("tableColumns.view"),
					renderCell: (params) => viewSection(params),
					minWidth: 110,
					maxWidth: 110,
					sortable: isColmnSortable(),
				},
				{
					field: "comments_count",
					headerName: t("tableColumns.comments"),
					renderCell: (params) => commentsSection(params),
					minWidth: 155,
					maxWidth: 155,
					sortable: isColmnSortable(),
				},
				{
					field: "action",
					headerName: t("tableColumns.action"),
					sortable: false,
					renderCell: (params) => downloadSection(params),
					minWidth: 100,
					maxWidth: 100,
				},
		  ]
		: [
				// {
				// 	field: "",
				// 	headerName: "",
				// 	sortable: false,
				// 	width: 100,
				// 	renderHeader: (params) => "",
				// 	renderCell: (params) => getSourceSvg(params.row.source),
				// 	// render:() => {<testElement />},
				// 	// valueGetter: (params) =>
				// 	// `${params.row.id || ''} ${params.row.name || ''}`,
				// 	// description: '',
				// 	// resizable: true,
				// },
				{
					field: "title",
					headerName: t("tableColumns.fileName"),
					renderCell: (params) => fileNameSection(params),
					flex: 0.5,
					minWidth: 150,
					sortable: isColmnSortable(),
				},
				{
					field: "pages",
					headerName: t("tableColumns.pages"),
					renderCell: (params) => showPageNumber(params),
					renderHeader: () => renderPageNumberHeader(),
					flex: 0.5,
					minWidth: 150,
					sortable: false,
				},
				{
					field: "author",
					headerName: t("tableColumns.author"),
					sortable: false,
					minWidth: 250,
					flex: 0.3,
				},
				{
					field: "tags",
					headerName: t("tableColumns.tag"),
					minWidth: 315,
					maxWidth: 315,
					renderHeader: () => renderTagHeader(),
					renderCell: getTags,
					sortable: false,
				},
				{
					field: "tagged_date",
					headerName: t("tableColumns.dateTime"),
					minWidth: 250,
					maxWidth: 270,
					renderCell: renderTaggedDate,
					sortable: isColmnSortable(),
				},
				{
					field: "view_count",
					headerName: t("tableColumns.view"),
					renderCell: (params) => viewSection(params),
					minWidth: 110,
					maxWidth: 110,
					sortable: isColmnSortable(),
				},
				{
					field: "comments_count",
					headerName: t("tableColumns.comments"),
					renderCell: (params) => commentsSection(params),
					minWidth: 155,
					maxWidth: 155,
					sortable: isColmnSortable(),
				},
				{
					field: "action",
					headerName: t("tableColumns.action"),
					sortable: false,
					renderCell: (params) => downloadSection(params),
					minWidth: 100,
					maxWidth: 100,
				},
		  ]

	const assigneeColumn = {
		field: "assignee",
		sortable: false,
		headerName: "Assignee",
		renderCell: (params) => assigneeSection(params),
		minWidth: 250,
		maxWidth: 270,
	}

	const assigneeSelection = {
		field: "assigneeSelection",
		sortable: false,
		headerName: "",
		renderCell: (params) => assigneeSelectionSection(params),
		renderHeader: () => renderAsigneeSelectionHeader(),
		minWidth: 65,
		maxWidth: 65,
	}

	const downloadFileSelection = {
		field: "downloadFileSelection",
		sortable: false,
		headerName: "",
		renderCell: (params) => downloadFileSelectionSection(params),
		renderHeader: () => renderDownloadFileHeader(),
		minWidth: 25,
		maxWidth: 25,
	}

	if (Object.keys(reviewAssignee).length) {
		columns.splice(1, 0, assigneeColumn) //Add assignee column on the 2nd position
	}

	if (isReviewFormOpen) {
		columns.splice(0, 0, assigneeSelection) //Add checkbox column on the 1st position
	} else {
		columns.splice(0, 0, downloadFileSelection) //Add checkbox column on the 1st position
	}

	return columns
}

export { getAllDocumentsTableColumns }
